// hooks/useDocumentCheckerStatus.js
import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = "https://formbuilderapi.getforsite.com"; //process.env.REACT_APP_API_URL ||
const useDocumentCheckerStatus = (formStructure, userId) => {
  const [documentStatuses, setDocumentStatuses] = useState({});

  useEffect(() => {
    const fetchStatuses = async () => {
      if (!formStructure?.modules || !userId) return;

      const checkerModules = formStructure.modules.filter(
        (mod) => mod.type === "document_checker" && mod.selectedQuestionnaireId,
      );

      if (checkerModules.length === 0) return;

      const statuses = {};

      await Promise.all(
        checkerModules.map(async (mod) => {
          try {
            const res = await axios.get(
              `${API_BASE_URL}/api/docs/document-checker/status`,
              {
                params: {
                  questionnaire_id: mod.selectedQuestionnaireId,
                  user_id: userId,
                },
              },
            );

            statuses[mod.id] = res.data.hasDocument; // API returns { hasDocument: true/false }
          } catch (error) {
            console.error(
              `Error fetching document status for module ${mod.id}`,
              error,
            );
            statuses[mod.id] = false; // Default status if error occurs
          }
        }),
      );

      setDocumentStatuses(statuses);
    };

    fetchStatuses();
  }, [formStructure, userId]);

  return documentStatuses;
};

export default useDocumentCheckerStatus;
